import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLockup } from "@/components/Brand";

const CONTACT = "[contato da igreja]";

const SECTIONS = [
  ["Quem cuida dos seus dados", ["A Igreja Unida Deus Proverá é a responsável pelos dados recebidos pelo ZAP IUDP – Central Digital."]],
  ["Quais dados guardamos", [
    "Nome completo, WhatsApp com DDD, cidade e estado informados no cadastro.",
    "Tudo o que você envia na conversa: mensagens, áudios, fotografias, documentos e comprovantes Pix.",
    "Data e horário de cada envio, o link de divulgação pelo qual você chegou (quando houver) e um registro protegido do acesso, sem guardar o endereço de internet em texto aberto.",
    "Não usamos localização por GPS.",
  ]],
  ["Para que usamos", [
    "Atender você: ler e responder mensagens, pedidos de oração, testemunhos e solicitações Deus Proverá.",
    "Conferir comprovantes Pix enviados. O envio do comprovante não é uma confirmação bancária automática.",
    "Enviar mensagens pelo WhatsApp, conforme a autorização dada no cadastro.",
    "Fazer relatórios internos com números de participação, sem divulgar dados pessoais.",
    "Não vendemos seus dados e não os usamos para outras finalidades.",
  ]],
  ["Quem mais tem acesso", [
    "Somente a equipe autorizada da igreja, com login protegido.",
    "Serviços técnicos contratados para funcionar: hospedagem, armazenamento seguro de arquivos e um serviço de inteligência artificial que ajuda a organizar mensagens escritas quando a classificação automática tem dúvida. Esses serviços não usam seus dados para outros fins.",
  ]],
  ["Como protegemos", [
    "Conexão segura (HTTPS), painel administrativo com login, arquivos guardados em armazenamento protegido, limites de tamanho e tipo de arquivo e registro das ações da equipe.",
  ]],
  ["Por quanto tempo", ["Enquanto você participar da Central Digital ou até pedir a exclusão."]],
  ["Seus direitos", [
    "Ver seus dados: na conversa, toque no ícone de pessoa no alto da tela (Meus dados).",
    "Pedir correção ou exclusão: no mesmo lugar, use os botões de pedido. A equipe fará o atendimento.",
    "Retirar a autorização de mensagens pelo WhatsApp: peça na própria conversa.",
    `Outras dúvidas: ${CONTACT}.`,
  ]],
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <header className="flex h-[68px] items-center border-b border-[#C9A24A]/30 bg-zap-deep px-3 text-white sm:px-5">
        <BrandLockup logoClass="h-[42px] min-[380px]:h-[52px]" />
      </header>
      <main data-testid="privacy-page" className="mx-auto max-w-2xl space-y-7 px-5 py-8 text-[17px] leading-relaxed text-zap-ink">
        <Link to="/" data-testid="privacy-back" className="inline-flex h-12 items-center gap-2 font-semibold text-zap-deep"><ArrowLeft className="h-5 w-5" />Voltar para a conversa</Link>
        <h1 className="font-display text-3xl font-semibold">Política de Privacidade</h1>
        <p className="text-base text-muted-foreground">Atualizada em 23/10/2026. Segue a Lei Geral de Proteção de Dados (LGPD).</p>
        {SECTIONS.map(([t, items]) => (
          <section key={t} className="space-y-2">
            <h2 className="font-display text-xl font-semibold text-zap-deep">{t}</h2>
            <ul className="list-disc space-y-1.5 pl-5">{items.map((i) => <li key={i}>{i}</li>)}</ul>
          </section>
        ))}
      </main>
    </div>
  );
}
